import React from 'react';
import images from '../constants/images';

const Logo = ({ className = "h-12", showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img 
        src={images.logo} 
        alt="nextvial" 
        className="h-full w-auto object-contain"
        onError={(e) => {
          // If image fails, we could show a text-based logo or fallback
          console.warn("Logo image failed to load");
        }}
      />
      {showText && (
        <span className="font-Gibson font-bold text-2xl tracking-tight flex items-center">
          <span style={{ color: '#003B5C' }}>next</span>
          <span style={{ 
            background: 'linear-gradient(135deg, #0072CE 0%, #38B44A 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginLeft: '2px'
          }}>vial</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
